import { TranslationKeys } from '~frontend-common/i18n/english/receipt.i18n';

const keys: TranslationKeys = {
  receipt: {
    coverages: {
      aboveGroundWater: {
        title: 'Dommages causés par l’eau au dessus du sol',
      },
      accidentBenefits_34: {
        title: 'L’assurance de personnes (FAQ 34)',
      },
      additionnalLivingCost: {
        title: 'Frais de subsistance supplémentaires',
      },
      bettermentsAndImprovements: {
        title: 'Améliorations locatives et rénovations',
      },
      burglary: {
        title: 'Vol et cambriolage',
      },
      caregiver: {
        title: 'Avantages pour les aidants',
        value: {
          included: 'Étendu',
          notIncluded: 'Base',
        },
      },
      changeToDeductible_41: {
        title: {
          on: 'Change to deductible (OPCF 41)',
          qc: 'Modification aux franchises (FAQ 41)',
        },
      },
      collisionNotFault: {
        title: 'Collision (non responsable)',
      },
      collision_b2: {
        title: {
          on: 'Collision (responsable)',
          qc: 'Collision et renversement (Chapitre B2)',
        },
      },
      comprehensive_b3: {
        title: {
          on: 'Accidents',
          qc: 'Accidents (Chapitre B3)',
        },
      },
      contingencyLiability: {
        title: 'Protection complémentaire',
      },
      core: {
        deductible: 'Franchise',
        included: 'Inclus',
        notInclude: 'Non inclus',
      },
      deductible: {
        title: 'Choisissez votre franchise',
      },
      dependentCare: {
        title: 'Prestations de soins aux personnes à charge',
      },
      detachedStructures: {
        title: 'Structures Détachées',
      },
      earthquakes: {
        title: 'Tremblement de terre (excluant les dommages causés par le feu)',
      },
      familyProtection: {
        title: 'Protection de la famille (FMPO 44)',
      },
      fire: {
        title: 'Feu et fumée',
      },
      fireAfterEarthquake: {
        title: 'Feu suite à un tremblement de terre (excluant tout autre dommage)',
      },
      funeral: {
        title: 'Prestations funéraires',
        value: {
          included: 'Étendu',
          notIncluded: 'Base',
        },
      },
      house: {
        title: 'Maison',
      },
      identityTheft: {
        title: "Vol d'identité",
      },
      incomeReplacement: {
        title: 'Prestations de remplacement du revenu',
        value: {
          notIncluded: '400 $',
        },
      },
      indexation: {
        title: "Indemnités d'indexation",
      },
      liabilityNonOwnedVehicle_2: {
        title: 'Véhicules non désignés (FAQ 2)',
      },
      lossAssessmentLiability: {
        title: 'Répartition de la responsabilité civile',
      },
      lossAssessmentProperty: {
        title: 'Répartition des dommages matériels',
      },
      medicalCatastrophicInjury: {
        title: 'Bénéfices médicaux (blessures graves)',
        value: {
          included: 'Étendu',
          notIncluded: 'Base',
        },
      },
      medicalExpenses: {
        title: 'Frais médicaux',
      },
      medicalNonCatastrophicInjury: {
        title: 'Bénéfice médical (blessure non grave)',
        value: {
          notIncluded: '65 000$',
        },
      },
      nonOwnedVehicle_27: {
        title: {
          on: 'Véhicules loués ou empruntés (FMPO 27)',
          qc: 'Véhicules loués ou empruntés (FAQ 27)',
        },
      },
      personalLiability: {
        title: 'Responsabilité civile',
      },
      personalProperty: {
        title: 'Biens personnels',
      },
      pool: {
        title: 'Piscine',
      },
      spa: {
        title: 'Spa',
      },
      replacementCarValue_43ae: {
        title: {
          on: 'Valeur à neuf (FMPO  43)',
          qc: 'Valeur à neuf (FAQ 43A-E)',
        },
      },
      rentOrLeased: {
        title: {
          on: 'Véhicules loués ou pris en crédit-bail (FMPO 5)',
          qc: 'Véhicules loués ou pris en crédit-bail (FAQ 5a)',
        },
      },
      roadAssistance_33: {
        title: {
          on: 'Assistance routière (FMPO 35)',
          qc: 'Assistance routière (FAQ 33)',
        },
      },
      thirdLiability_a: {
        title: {
          on: 'Responsabilité civile',
          qc: 'Responsabilité civile (Chapitre A)',
        },
      },
      travelCosts_20a: {
        title: {
          on: 'Frais de déplacement (FMPO 20)',
          qc: 'Frais de déplacement (FAQ 20)',
        },
      },
      uninsuredAutomobile: {
        title: 'Automobile non assurée',
      },
      voluntaryProperty: {
        title: 'Dommages matériels',
      },
      waterEntry: {
        title: "Bris d'entrée d'eau",
      },
      waterPackage: {
        title: "Dommages causés par l'eau de surface / refoulement d'égouts",
      },
      wind: {
        title: 'Vent',
      },
    },
    sections: {
      floaters: 'Couvertures pour biens spécifiques',
      primaryCoverages: 'Couvertures principales',
      secondaryCoverages: 'Couvertures additionnelles',
      ternaryCoverages: "Indemnités d'accident",
    },
    billing: {
      frequency: {
        annually: {
          name: 'Annuellement',
          paymentsCount: 'Un paiement de',
        },
        monthly: {
          name: 'Mensuellement',
          paymentsCount: 'Paiement mensuel de',
        },
      },
    },
  },
};

export default keys;
